import { Link } from 'react-router-dom';
import evergreenPages from '../../evergreen-pages.json';

type EvergreenPage = {
  slug: string;
  h1: string;
  description: string;
};

export function EvergreenLinks({ currentSlug, slugs }: { currentSlug?: string; slugs?: string[] }) {
  const pages = (evergreenPages as EvergreenPage[])
    .filter((page) => page.slug !== currentSlug)
    .filter((page) => !slugs || slugs.includes(page.slug));

  return (
    <nav aria-label="Popular Bali rental searches" className="my-6">
      <div className="flex flex-wrap gap-2">
        {pages.map((page) => (
          <Link
            key={page.slug}
            to={`/rentals/${page.slug}`}
            className="rounded-md border border-emerald-100 bg-white px-3 py-2 text-sm font-medium text-emerald-900 hover:border-emerald-300 hover:bg-emerald-50"
            title={page.description}
          >
            {page.h1}
          </Link>
        ))}
      </div>
    </nav>
  );
}
